import { COACH_METRICS } from '../data/constants';
import { getMetricStatus } from '../utils/drumHelpers';

interface CoachMetricsProps {
  metrics: Record<string, number | null | undefined>;
  language: string;
  className?: string;
}

function CoachMetrics({ metrics, language, className = '' }: CoachMetricsProps) {
  return (
    <div className={`coach-metrics ${className}`}>
      {COACH_METRICS.map(([key, ko, en]) => {
        const score = metrics[key] ?? 0;
        return (
          <div className="coach-metric" key={key}>
            <div><span>{language === 'ko' ? ko : en}</span><strong>{getMetricStatus(score, language)}</strong></div>
            <b><i style={{ width: `${score}%` }} /></b>
          </div>
        );
      })}
    </div>
  );
}

export default CoachMetrics;
